<script>
  import setWindowHistory from "@utils/window-history";

  export default {
    props: {
      value: {
        type: Object,
        default: () => {
          return {}
        }
      },
      loading: {
        type: Boolean,
        default: false
      },
      list: {
        type: Array,
        default: () => {
          return [
            {
              width: '20%',                 // [%, px, rem, em, vw, vh]
              type: 'text',                 // 必填 [ text, select, mouth, submit ]
              placeholder: 'placeholder',
              name: 'name',                 // 必填
              options: [
                {
                  text: 'text',
                  value: 'value',
                }
              ],
            }
          ]
        }
      },
      submitText: {
        type: String,
        default: '搜尋'
      },
    },
    computed: {
      submitData: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        },
      },
    },
    methods: {
      onSubmit() {
        const query = () => {
          const query = {};

          Object.keys(this.submitData)
            .forEach(key => {
              query[key] = this.submitData[key] || undefined
            });

          return query;
        };

        setWindowHistory({
          query: {
            ...this.$route.query,
            ...query()
          }
        });

        this.$emit('search', this.submitData)
      },
    }
  }
</script>
<template>
  <BaseSearchBar
    v-model="submitData"
    :loading="loading"
    :list="list"
    :submit-text="submitText"
    :class="$style.baseSearchBar2"
    @search="onSubmit"
  />
</template>
<style lang="scss" module>
  .baseSearchBar2 {
    :global {
      .baseSearchBar2 {

      }
    }
  }
</style>
